import { NgComponentOutlet } from '@angular/common';
import { Component } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { DynamicComponent, Footer } from '@shared/models';

import { Variant1Component } from './variant1/variant1.component';
import { Variant2Component } from './variant2/variant2.component';

@Component({
  selector: 'b2c-footer',
  imports: [NgComponentOutlet],
  templateUrl: './footer.component.html',
})
export class FooterComponent extends BaseComponent {
  public config: Footer = this.loyaltyChallengeConfig.components.footer;

  public components: DynamicComponent<Footer> = {
    [this.Variants.VARIANT_1]: {
      component: Variant1Component,
      inputs: { config: this.config },
    },
    [this.Variants.VARIANT_2]: {
      component: Variant2Component,
      inputs: { config: this.config },
    },
  };
}
